import { maybeGetProjectUpdateAriFromUrlUpdateId } from '@townsquare/project-update-card/ari-utils';
import { createRelayResource } from '@townsquare/relay-utils';
import { ResourceContext } from '@townsquare/router/types';

import ProjectEmbedQuery, {
	type ProjectEmbedQuery as ProjectEmbedQueryType,
} from '../components/Project/__generated__/ProjectEmbedQuery.graphql';

export const projectEmbedResource = createRelayResource<ProjectEmbedQueryType>({
	getQuery: (routerContext, resourceContext) => {
		const projectKey = routerContext.match.params.projectKey;
		const tabName = routerContext.match.params.tabName;

		const context = resourceContext as ResourceContext;
		const updateId = maybeGetProjectUpdateAriFromUrlUpdateId(
			routerContext.query.updateId,
			context.workspace?.cloudId,
		);

		return {
			query: ProjectEmbedQuery,
			variables: {
				key: projectKey || '',
				tabName: tabName || '',
				id: updateId || '',
				isSpecificUpdate: !!updateId,
			},
		};
	},
});
